import { useEffect, useState } from 'react'

const useAccountingData = (data, accountingLabels, objectCheck, t, option) => {
	const [accountingData, setAccountingData] = useState({})

	useEffect(() => {
		const salesNames = [
			t('options_section.fields.accountingReduced'),
			t('options_section.fields.accountingNormal'),
			t('options_section.fields.accountingZeroPercent'),
			t('options_section.fields.accountingSpecial'),
		]
		const salesNames1 = [
			t('closing_section.fields.vat_reduced'),
			t('closing_section.fields.vat_normal'),
			t('options_section.fields.taxAccountZeroPercent')
		]
		const salesNames2 = [
			t('options_section.fields.taxCodeReduced'),
			t('options_section.fields.taxCodeNormal'),
			t('options_section.fields.taxCodeZeroPercent'),
			t('options_section.fields.taxCodeZeroSpetial'),
		]
		if(objectCheck(data) && objectCheck(accountingLabels)) {
			setAccountingData({
				general: [
					{ label: t('options_section.fields.client_number'), value: data?.clientNum },
					{ label: t('options_section.fields.cost_centre'), value: data?.costCentre },
					{ label: t('options_section.fields.own_account'), value: data?.passAccount },
					{ label: t('options_section.fields.cashRegistersBar'), value: data?.cashRegisterAccount },
					{ label: t('options_section.fields.cashRegistersPlus'), value: data?.cashRegisterAccountDifference },
					{ label: t('options_section.fields.cashRegistersMinus'), value: data?.cashRegisterAccountDifferenceNegative },
					{ label: t('options_section.fields.tipsAccount'), value: data?.tipsAccount },
					{ label: t('options_section.fields.euros_in_CHF'), value: data?.euroInCHF },
					{ label: t('options_section.fields.skimming'), value: data?.cashRegisterAccountTransfer }
				],
				creditCards: rowsMaker(data?.credit, accountingLabels?.creditCards),
				accountPrepaidCard: [
					{ label: t('options_section.fields.customer_card_reference'), value: data?.accountPrepaidCard },
					{ label: t('options_section.fields.top_up_customer_card'), value: data?.accountPrepaidCardLoad },
					{ label: t('options_section.strings.loyalty_discount'), value: data?.accountPrepaidCardDiscount }

				],
				salesNames: rowsMaker(data?.incomeAccount, salesNames),
				taxAccountSorted: rowsMaker(data?.taxAccountSorted, salesNames1),
				taxCodeSorted: rowsMaker(data?.taxCodeSorted, salesNames2),
				outcome: rowsMaker(data?.outcome, accountingLabels?.specialProductExpenses)
			})
		}
	}, [data, accountingLabels, option])
	return accountingData
}

const rowsMaker = (cellData, labels) => {
	const resultArr = cellData.reduce((accumulator, value, i) => {
		const label = labels?.[i]
		if (label && label.length) {
			return([...accumulator, {
				label,
				value,
				originalIndex: i
			}])
		}
		return accumulator
	}, [])
	return(resultArr)
}

export default useAccountingData
